// extracted by mini-css-extract-plugin
export default {"BankCardList":"BankCardListContainer_BankCardList__2rlBC","BankCardList__sms":"BankCardListContainer_BankCardList__sms__yvCGN"};